var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 66,
    viewBox: "0 0 56 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4105 0H40.0247L55.9995 16.5446V61.4175C55.9995 63.9766 53.9515 66 51.4938 66H11.4105C8.89432 66 6.90479 63.9766 6.90479 61.4175V4.64202C6.90479 2.08296 8.89432 0 11.4105 0Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9991 16.5446H44.1204C41.8383 16.5446 39.9658 14.6402 39.9658 12.3192V0H40.0243L55.9991 16.5446Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 16.5447V28.6853L44.2969 16.5447H56Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9986 30.9996H2.39915C1.07413 30.9996 0 32.0387 0 33.3206V52.7814C0 54.0632 1.07413 55.1024 2.39915 55.1024H44.9986C46.3237 55.1024 47.3978 54.0632 47.3978 52.7814V33.3206C47.3978 32.0387 46.3237 30.9996 44.9986 30.9996Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8905 44.4549H13.3963V42.8549H15.8905C16.276 42.8549 16.5897 42.7911 16.8317 42.6634C17.0738 42.5312 17.2508 42.3489 17.3629 42.1164C17.4749 41.884 17.5309 41.6219 17.5309 41.3301C17.5309 41.0338 17.4749 40.758 17.3629 40.5028C17.2508 40.2475 17.0738 40.0424 16.8317 39.8874C16.5897 39.7324 16.276 39.6549 15.8905 39.6549H14.0955V48.0036H12.0786V38.0481H15.8905C16.657 38.0481 17.3136 38.1894 17.8604 38.472C18.4116 38.7501 18.833 39.1353 19.1243 39.6276C19.4156 40.1199 19.5613 40.6828 19.5613 41.3164C19.5613 41.9592 19.4156 42.5153 19.1243 42.9848C18.833 43.4543 18.4116 43.8167 17.8604 44.072C17.3136 44.3272 16.657 44.4549 15.8905 44.4549Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1548 48.0036H22.0236L22.0371 46.4036H24.1548C24.6837 46.4036 25.1296 46.2828 25.4927 46.0412C25.8557 45.795 26.1291 45.4372 26.3129 44.9677C26.5011 44.4982 26.5952 43.9307 26.5952 43.2651V42.7797C26.5952 42.2691 26.5414 41.8201 26.4339 41.4327C26.3308 41.0452 26.1762 40.7193 25.97 40.4549C25.7638 40.1905 25.5106 39.9922 25.2103 39.86C24.91 39.7233 24.5649 39.6549 24.175 39.6549H21.9833V38.0481H24.175C24.8293 38.0481 25.4277 38.1621 25.97 38.39C26.5168 38.6133 26.9896 38.9347 27.3885 39.3541C27.7874 39.7734 28.0944 40.2749 28.3096 40.8583C28.5292 41.4372 28.639 42.0822 28.639 42.7934V43.2651C28.639 43.9717 28.5292 44.6167 28.3096 45.2002C28.0944 45.7836 27.7874 46.2851 27.3885 46.7044C26.9941 47.1192 26.5213 47.4406 25.97 47.6685C25.4232 47.8919 24.8181 48.0036 24.1548 48.0036ZM23.1665 38.0481V48.0036H21.1496V38.0481H23.1665Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3182 38.0481V48.0036H30.3013V38.0481H32.3182ZM36.2175 42.301V43.901H31.7669V42.301H36.2175ZM36.6881 38.0481V39.6549H31.7669V38.0481H36.6881Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3977 52.788V55.0495C47.3977 56.3588 46.3444 57.3705 45.0571 57.3705H6.90479V55.109H45.0571C46.3444 55.109 47.3977 54.0378 47.3977 52.788Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.0ad16f26f6088317e697ded9e5029188.svg";
export { ForwardRef as ReactComponent };